import React, {useCallback, useEffect} from "react"
import {useDataSourceSource} from "./context"
import {useDatasourceMappingSearch} from "../datasource_mapping/search"
import SettingsSearch from "../search"
import {EmptyView} from "@ciq/shared/components/views"
import {PillGroup} from "@ciq/shared/components/pill"
import {ListView} from "@ciq/shared/components/list"

export function SourcePane({show}) {
  const {isLoaded, sources, hasSources, actions: sourceActions} = useDataSourceSource()
  const {search, actions: searchActions} = useDatasourceMappingSearch()

  useEffect(() => {
    if (show || hasSources) return

    sourceActions.reset()
    searchActions.reset()
  }, [hasSources, searchActions, show, sourceActions])

  useEffect(() => {
    if (!show || isLoaded) return
    sourceActions.getSources()
  }, [isLoaded, show, sourceActions])

  const handleOnAdd = useCallback(() => {
    sourceActions.loadSources()
  }, [sourceActions])

  if (!show) {
    return null
  }

  return (
    <div className="settings-users-list">
      <SettingsSearch
        search={search.term}
        onSearch={searchActions.set}
        buttonTitle="Load Sources"
        onAdd={handleOnAdd}
      />
      {!hasSources && <EmptyView>{!isLoaded ? "Loading..." : "No sources found."}</EmptyView>}
      {hasSources && (
        <ListView>
          {sources.map(source => (
            <Source
              key={source.id}
              source={source}
            />
          ))}
        </ListView>
      )}
    </div>
  )
}

function Source({source}) {
  return (
    <div className="settings-user-management-user">
      <div className="settings-user-management-user-header">
        <div>
          <span>{source.name}</span>
        </div>
        <div>
          {/*<EditButton onClick={() => onEdit(source)}/>*/}
          {/*<DeleteButton onClick={() => onDelete(source)}/>*/}
        </div>
      </div>
      <PillGroup className="settings-mappings-table-container">
        {source.tables.map(table => (
          <Table
            key={table.id}
            table={table}
          />
        ))}
        {source.tables.length === 0 && <EmptyView>Source has no tables</EmptyView>}
      </PillGroup>
    </div>
  )
}

function Table({table}) {
  const hasColumns = table.columns?.length > 0

  return (
    <div className="settings-mappings-container settings-mappings-table">
      <span className="settings-mappings-table-title">{table.name}</span>
      <div className="settings-mappings-columns">
        {hasColumns && table.columns.map(column => (
          <Column key={column.id} column={column}/>
        ))}
      </div>
    </div>
  )
}

function Column({column}) {
  return (
    <div className="settings-mappings-column">
      <span>{column.name}</span>
      <span>{column.type}</span>
    </div>
  )
}
